<template>
	<div class="vu-upload-images">
		<el-upload :class="{
			'hide-upload-button':  limit <= fileList.length
		}"
		    v-model:file-list="fileList"
		    :action="`${apiPrefix}${uploadUrl}`"
		    :headers="headers"
		    list-type="picture-card"
			:limit="limit"
			:data="extraData"
			accept="image/*"
			:before-upload="handleBeforeUpload"
		    :on-preview="handlePictureCardPreview"
			:on-success="handleImageSuccess"
		    :on-remove="handleImageRemove">
				<el-icon><Plus /></el-icon>
		  </el-upload>
		  <el-image-viewer v-if="imageViewerVisible" 
			:initial-index="imageViewerCurrent" 
			:url-list="imageViewList"
			@close="imageViewerVisible = false">
		  </el-image-viewer>
	</div>
</template>

<script setup> 
	import { useMessage } from '@/utils/message'
	import { post } from '@/utils/request'
	import { useStorage } from '@/utils/storage'
	
	const props = defineProps({
		modelValue: { type: [Array, String] },
		headers: { type: Object, default: ()=>({}) },
		limit: { type: Number, default: 1 },
		extraData: { type: [Object, Function] },
		uploadUrl: { type: String, required: true },
		heightX: { type: Number, default: 1 },
		widthX: { type: Number, default: 1 },
		beforeUpload: { type: Function },
		onSuccess: { type: Function }
	})
	const emits = defineEmits(['update:modelValue', 'remove'])
	
	const { headers, modelValue, heightX, widthX, onSuccess, beforeUpload } = toRefs(props)
	const token = useStorage('local').get('user-token')
	if(token) {
		headers.value['TOKEN'] = token
	}
	
	const apiPrefix = import.meta.env.VITE_APP_API_BASE;
	
	const fileList = ref([])
	const imageViewerCurrent = ref(0)
	const imageViewerVisible = ref(false)
	const imageViewList = computed(() => {
		return fileList.value.map(file => file.url)
	})
	// 刚打开  更新数据
	watch(modelValue, val => {
		if(!val) {
			return
		}
		
		if(Array.isArray(val)) {
			fileList.value = val.map(item => {
				const { id, url, name } = item
				return { id, url, name: name || url, status: 'success' }
			})
		}
		else {
			fileList.value = [{ id: 0, url: val, name: val, status: 'success' }]
		}
	}, { deep: true, immediate: true }) 
	
	const handlePictureCardPreview = (file) => {
		imageViewerCurrent.value = imageViewList.value.indexOf(file.url)
		imageViewerVisible.value = true 
	}
	
	const handleBeforeUpload = () => {
		beforeUpload.value && beforeUpload.value.call(this)
	}
	
	const handleImageSuccess = (res, file, files) => {
		if(res.code != 0) {
			useMessage('上传失败').show('error')
			return 
		} 
		
		useMessage('上传成功').show('success') 
		
		const { id, url } = res.data
		const dataList = fileList.value.filter(file => !file.response || file.response.code == 0)
							.map(file => { 
								if(!file.response) {
									return {...file}
								}
								
								const { name } = file 
								const { id, url } = file.response.data
								return { id, name, url }
							})
		
		emits('update:modelValue', dataList)
		
		onSuccess.value && onSuccess.value.call(this, dataList) 
	}
	
	const heightPx = (heightX.value * 150) + 'px';
	const widthPx = (widthX.value * 150) + 'px';
	
	const handleImageRemove = (file, files) => {
		const idx = fileList.value.findIndex(item => {
			item.url === file.url
		})
		const removedFile = fileList.value.splice(idx);
		
		emits('update:modelValue', fileList.value)
		
		emits('remove', removedFile)
	}
</script>

<style lang="scss" scoped>
	.vu-upload-images {
		.hide-upload-button {
			:deep(.el-upload-list) {
				.el-upload {
					display: none !important;
				}
			}
		}
		
		:deep(.el-upload--picture-card) {
			height: v-bind(heightPx) !important;
			width: v-bind(widthPx) !important;
		}
		
		:deep(.el-upload-list--picture-card) {
			.el-upload-list__item {
				height: v-bind(heightPx) !important;
				width: v-bind(widthPx) !important;
			}
		}
	}
	
	.preview-content {
		height: calc(100vh - 50px);
		
		.preview-image {
			max-width: 100%;
		}
	}
</style>